<script setup>
import { router } from '@inertiajs/vue3'

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const footer_menu = router.page.props.ziggy.front_end_footer_menu;

let urlNamePrefix = '';

if (organisation) {
    urlNamePrefix = "gi.";
} else if (!organisation && !programme) {
    urlNamePrefix = "platform.";
}
</script>
<template>
    <footer id="sos-app-footer" class="">

        <div class="container mx-auto flex flex-row justify-items-end justify-end w-full pt-5 pb-5">

            <div id="sos-footer-menu">
                <div>
                    <ul class="md:flex md:flex-row text-sm">
                        <li v-for="item in footer_menu">
                            <a :href="route(urlNamePrefix+'page', {page:item.slug})">{{item.title[$i18n.locale] ? item.title[$i18n.locale] : item.title[$i18n.fallbackLocale]}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
